<template>
  <div v-if="loaded">
    <div class="col-12 pt2">
      <div class="flex justify-center flex-wrap px3">
        <Alert v-if="errorMessage" :message="errorMessage" icon="attention" color="error" />
        <div class="col-12 pb3">
          <label class="h6n bold" for="centers"> {{ getReferencelabel("CHOOSE_CENTER") }} <span class="red"> *</span></label>
          <div class="relative border white-bg col-12 mb1">
            <select
              ref="centers"
              v-model="data['center']"
              class="border-none relative z2 col-12 pl2 input-height"
            >
              <option
                v-for="(center, centerIndex) in centersList.value"
                :key="centerIndex"
                :value="center.uuid"
              >
                {{ center.center_name }}
              </option>
            </select>
            <span
              class="absolute red right-0 flex items-center mr1 top-0 bottom-0"
            >
              <i class="icon mt1 icon-chevron-down"></i>
            </span>
          </div>
        </div>

        <div class="col-12 white-bg py2">
          <div class="px3">
            <label class="h6n bold" for="contacts">
              {{ getReferencelabel("CHOOSE_BENEFICIARY") }}
              <span class="red"> *</span></label>
            <div class="relative border white-bg col-12 mb1">
              <select
                ref="centers"
                v-model="data['contact']"
                class="border-none relative z2 col-12 pl2 input-height"
                @change="fillFields"
              >
                <option
                  value=""
                >
                </option>
                <option
                  v-for="(contact, contactIndex) in users"
                  :key="contactIndex"
                  :value="contact.uuid"
                >
                  {{ contact.lastname }} {{ contact.firstname }} {{ contact.birth_date }}
                </option>
              </select>
              <span class="absolute red right-0 flex items-center mr1 top-0 bottom-0">
                <i class="icon mt1 icon-chevron-down"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="center pt2">
          <h4 class="h4n m0">{{ getReferencelabel("OR") }}</h4>
          <span>
            {{ getReferencelabel("NEW_PROFILE_UNDER") }}
          </span>
        </div>
      </div>
      <div :class="{'disabled': data.contact}">
        <GenerateForm
          v-model="isValidForm"
          :form="form"
          :data="data"
          :save-action="saveData"
          :visible-actions="false"
        />
      </div>
    </div>

    <div class="flex justify-center flex-wrap pb2 ">
      <Button
        reference="CREATE_WALLET_NEW"
        class="col-9 md-col-5 px2"
        :disabled="!validateFields"
        btn-color="blue"
        :action="saveData"
      />

       <Button
        reference="BACK_TO_WALLET_LIST"
        class="col-9 md-col-5 px2 sm-pt2"
        btn-color="blue"
        :action="backToWalletList"
      />
    </div>
    
  </div>
</template>
<script>
import { computed, reactive, ref, onMounted } from 'vue';
import { useStore } from 'vuex';

import { useRouter, useRoute } from 'vue-router';
import GenerateForm from '@/components/common/GenerateForm';
import Button from '@/components/elements/Button';

import { createWallet, getCenters } from '@/mixins/requests';
import { isObjectEmpty, getReferencelabel } from '@/mixins/utils';
import Alert from '@/components/common/Alert';

export default {
  components: {
    GenerateForm,
    Button,
    Alert
  },
  setup () {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const centersList = reactive({});
    const loaded = ref(false);

    const isValidForm = ref(false);
    const errorMessage = ref(null);

    const data = reactive({
      center: null,
      contact: null,
      gender: null,
      firstname: null,
      lastname: null,
      birth_date: null,
      email: null
    });

    const form = require('@/configs/profileForm.json');

    const users = ref([]);
    users.value = users.value.concat(store.getters.contacts);
    users.value.unshift(store.state.user);

    const validateFields = computed(() => {
      let isValid = false;

      if (data.contact && isValidForm.value && data.center) {
        isValid = true;
      }

      if (!data.contact && isValidForm.value && data.center) {
        isValid = true;
      }

      return isValid;
    });

    function fillFields () {
      if (data.contact && data.contact.trim()) {
        const contact = users.value.find(c => c.uuid === data.contact);
        data.uuid = contact.uuid;
        data.gender = contact.gender;
        data.firstname = contact.firstname;
        data.lastname = contact.lastname;
        data.birth_date = contact.birth_date;
        data.email = contact.email;
      } else {
        data.uuid = null;
      }
    }

    async function syncCenters () {
      store.commit('setLoading', true);
      centersList.value = store.state.centers;

      if (!centersList.length) {
        const centers = await getCenters();
        centersList.value = centers.count ? centers.items : [];
        store.commit('setCenters', centersList.items);
      }
      loaded.value = true;
      store.commit('setLoading', false);
    }

    function setCenter () {
      const { center } = route.query;
      if (center && centersList.value.some(c => c.uuid === center)) {
        data.center = center;
      }
    }

    onMounted(async () => {
      await syncCenters();
      setCenter();
    });

    function backToWalletList() {
        router.push({ name: 'Wallets List' });
    }

    async function saveData () {
      errorMessage.value = ''
      store.commit('setLoading', true);
      const response = await createWallet(data);
      
      if (response.success) {
        if (!response.data.wallet.createWallet){
          errorMessage.value = 'WALLET_ERROR'
          store.commit('setLoading', false);
        }
        else if (!response.data.wallet.createWallet.success) {
          errorMessage.value = 'WALLET_EXIST_USER'
          store.commit('setLoading', false);
        } else {
          setTimeout(() => {
            router.replace({ name: 'Wallets List' });
            store.commit('setLoading', false);
          }, 5000);
        }
      }
    }

    return {
      saveData,
      isObjectEmpty,
      store,
      users,
      loaded,
      centersList,
      data,
      validateFields,
      fillFields,
      form,
      isValidForm,
      getReferencelabel,
      errorMessage,
      backToWalletList
    };
  }
};
</script>
